module.exports = __webpack_public_path__ + "static/media/events.8b384f9e.png";